import { MobileOsType } from '@modules/test-development/enums/mobile-os-type.enum';
import { alias, custom, deserialize, serializable, SKIP } from 'serializr';
import { Base } from './base.model';
import { PageObject } from './page-object.model';
import { Agent } from './agent.model';

export class AgentDevice extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public uniqueId: string;
  @serializable
  public productModel: string;
  @serializable
  public apiLevel: string;
  @serializable
  public osVersion: string;
  @serializable
  public osName: MobileOsType;
  @serializable
  public abi: string;
  @serializable
  public isEmulator: boolean;
  @serializable
  public isOnline: boolean;
  @serializable
  public screenWidth: number;
  @serializable
  public screenHeight: number;
  @serializable
  public mirroringById: number;
  @serializable
  public provisioned: boolean;
  public isDisabled: boolean;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public error: string;
  @serializable(
    custom(
      () => SKIP,
      (v) => v,
    ),
  )
  public isInitialised: boolean;
  @serializable(alias('name'))
  public displayName: string;
  @serializable(
    custom(
      (v) => v,
      (v) => {
        if (v) return new Agent().deserialize(v);
      },
    ),
  )
  public agent: Agent;
  deserialize(input: any): this {
    return Object.assign(this, deserialize(AgentDevice, input));
  }
  get isIOS(): boolean {
    return this.osName === MobileOsType.IOS;
  }

  get isAndroid(): boolean {
    return this.osName === MobileOsType.ANDROID;
  }
}
